import { Turbo } from "@hotwired/turbo-rails";

let currentResolution: ((answer: boolean) => void) | undefined;
let currentCleanup: (() => void) | undefined;

export function installConfirmModal() {
  Turbo.config.forms.confirm = (message, _formElement, submitter) => (
    confirmWithModal(message, submitter)
  );
}

function confirmWithModal(message: string, submitter?: HTMLElement | null) {
  const dialog = document.querySelector<HTMLDialogElement>("[data-confirm-modal]");
  if (!dialog) return Promise.resolve(window.confirm(message));

  closeCurrentModal(false);

  const messageElement = dialog.querySelector<HTMLElement>("[data-confirm-modal-message]");
  const cancelButton = dialog.querySelector<HTMLButtonElement>("[data-confirm-modal-cancel]");
  const confirmButton = dialog.querySelector<HTMLButtonElement>("[data-confirm-modal-confirm]");
  const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : undefined;

  if (!messageElement || !cancelButton || !confirmButton) {
    return Promise.resolve(window.confirm(message));
  }

  messageElement.textContent = message;
  confirmButton.textContent = confirmLabelFor(submitter);
  confirmButton.classList.toggle("danger", destructiveSubmitter(submitter));

  return new Promise<boolean>((resolve) => {
    currentResolution = resolve;

    const complete = (answer: boolean) => {
      cleanup();
      if (dialog.open) dialog.close();
      previousFocus?.focus();
      currentCleanup = undefined;
      currentResolution = undefined;
      resolve(answer);
    };

    const cancel = (event: Event) => {
      event.preventDefault();
      complete(false);
    };

    const confirm = () => complete(true);

    const closeFromBackdrop = (event: MouseEvent) => {
      if (event.target === dialog) complete(false);
    };

    const cleanup = () => {
      dialog.removeEventListener("cancel", cancel);
      dialog.removeEventListener("click", closeFromBackdrop);
      cancelButton.removeEventListener("click", cancel);
      confirmButton.removeEventListener("click", confirm);
    };

    currentCleanup = cleanup;

    dialog.addEventListener("cancel", cancel);
    dialog.addEventListener("click", closeFromBackdrop);
    cancelButton.addEventListener("click", cancel);
    confirmButton.addEventListener("click", confirm);

    dialog.showModal();
    cancelButton.focus();
  });
}

function closeCurrentModal(answer: boolean) {
  currentCleanup?.();
  currentCleanup = undefined;

  const dialog = document.querySelector<HTMLDialogElement>("[data-confirm-modal]");
  if (dialog?.open) dialog.close();

  currentResolution?.(answer);
  currentResolution = undefined;
}

function confirmLabelFor(submitter?: HTMLElement | null) {
  return submitter?.textContent?.trim() || "Confirm";
}

function destructiveSubmitter(submitter?: HTMLElement | null) {
  return Boolean(submitter?.classList.contains("danger"));
}
